import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
    private platformId = inject(PLATFORM_ID);

    private get isBrowser(): boolean {
        return isPlatformBrowser(this.platformId);
    }

    private get gtag(): ((...args: any[]) => void) | undefined {
        if (this.isBrowser && typeof window.gtag === 'function') {
            return window.gtag;
        }
        return undefined;
    }

    // Inicializa GA con el ID del environment (llamar solo una vez desde AppComponent)
    init(): void {
        if (!this.isBrowser) return;

        this.gtag?.('config', environment.GA_MEASUREMENT_ID, {
            send_page_view: false, // los page_view los gestiona trackPageView()
            debug_mode: false // activar solo para testing local junto a la extensión de chrome Google Analytics Debugger
        });

        // inyectamos el script con el ID correcto según el environment.
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${environment.GA_MEASUREMENT_ID}`;
        document.head.appendChild(script);
    }

    // ─── Consentimiento ───
    grantConsent(): void {
        this.gtag?.('consent', 'update', {
            analytics_storage: 'granted',
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied'
        });
    }

    denyConsent(): void {
        this.gtag?.('consent', 'update', {
            analytics_storage: 'denied',
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied'
        });
    }

    // ─── Evento genérico ───────────────────────────────────────────────────────

    trackEvent(eventName: string, params: Record<string, any> = {}): void {
        this.gtag?.('event', eventName, params);
    }

    // ─── Eventos de Home ───────────────────────────────────────────────────────

    trackSeePlans(label: string = 'hero_see_plans'): void {
        this.trackEvent('see_plans', {
            event_category: 'engagement',
            event_label: label
        });
    }

    trackProfessionalView(id: string, name: string): void {
        this.trackEvent('see_professional', {
            event_category: 'engagement',
            event_label: name,
            professional_id: id
        });
    }

    trackPurchaseClick(planName: string, billingCycle: string): void {
        this.trackEvent('purchase_plan', {
            event_category: 'ecommerce',
            event_label: planName,
            plan_type: planName,
            billing_cycle: billingCycle
        });
    }


    trackPageView(pagePath: string, pageTitle?: string): void {
        this.gtag?.('config', environment.GA_MEASUREMENT_ID, {
            page_path: pagePath,
            ...(pageTitle ? { page_title: pageTitle } : {})
        });
    }


    trackContactFormSubmit(usertype: string): void {
        this.trackEvent('contact_form_submit', {
            event_category: 'engagement',
            event_label: usertype
        });
    }

    trackCalendarClick(page: string): void {
        this.trackEvent(`${page}_calendar_click`, {
            event_category: 'engagement',
            event_label: 'calendar_click'
        });
    }
}
